import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ResponsiveService } from '@x/common/responsive';
import { SearchUiStateService } from '@x/ecommerce-shop/app/core/search/services/search-ui-state.service';
import { Observable, Subscription } from 'rxjs';
import { filter, map, shareReplay, startWith } from 'rxjs/operators';

@Component({
  selector: 'x-search-button',
  templateUrl: './search-button.component.html',
  styleUrls: ['./search-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchButtonComponent implements OnInit, OnDestroy {
  private _subscription = new Subscription();

  hideOnRoutes = ['/ps/'];

  get hide(): boolean {
    return this.hideOnRoutes.some((route) => this.router.url.includes(route));
  }

  open: boolean = false;
  
  setOpen(value: boolean) {
    this.open = value;
    if (value) {
      this.searchUiStateService.openSearch();
    }
  }

  overlayKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.setOpen(false);
    }
  }

  show$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => !this.hide),
    startWith(!this.hide),
    shareReplay(),
  );

  constructor(
    private router: Router,
    private searchUiStateService: SearchUiStateService,
    private cd: ChangeDetectorRef,
    private rs: ResponsiveService,
  ) {}

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  ngOnInit(): void {
    this._subscription.add(
      this.searchUiStateService.searchClosed.subscribe(() => {
        this.open = false;
        this.cd.detectChanges();
      }),
    );
  }

  outsideClick($event: MouseEvent) {
    const eventTarget = $event.target as HTMLElement;

    const isSearchButton = eventTarget?.parentElement?.classList.contains('search-button');

    if (isSearchButton) return;

    this.setOpen(false);
    this.cd.detectChanges();
  }

  onMouseOver() {
    if (this.rs.isBreakpoint({ min: 'MD' })) {
      this.setOpen(true);
      this.cd.detectChanges();
    }
  }
}
